export const LOCALES = {
  en: 'English',
  es: 'Spanish'
};
